<template>
      <span><slot></slot></span>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

span {
  color: white;
  &.black{
    color:black;
  }
  font-weight: bolder;
  font-size: 1em;
  text-transform: uppercase;
  filter:drop-shadow(1px 1px 20px rgba(0,0,0,0.5));
  display: inline-block;
  border: 4px solid currentColor;
  padding: .1em .5em;
  border-radius: 100px;
  z-index: 3;
  @include for-size(phone-only) {
    padding: .2em .6em;
    font-size: 1em;
    border: 3px solid currentColor;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/elements/Tag.vue